// import { MontserratBolditalic } from 'lib/assets/fonts';

import { combine } from "../../utils/styles";
import AnimConnexion2 from '../../assets/animations/1framelogin.json';
import AnimConnexion from '../../assets/animations/connexion-lottie.json';
import AnimSecondPart from '../../assets/animations/secondPart.json';
import PicsAccelerateur from '../../assets/images/accelerateur.png';
import PicsApple from '../../assets/images/apple.png';
import PicsArnaud from '../../assets/images/ArnaudBICHI.png';
import BackgroundAbout from '../../assets/images/BackgroundAbout.png';
import backgroundBuild from '../../assets/images/backgroundBuild.png';
import BackgroundCloud from '../../assets/images/backgroundCloud.png';
import PicsFormBackground from '../../assets/images/backgroundForm.png';
import BackgroundHome from '../../assets/images/BackgroundHome.jpg';
import BackgroundMap from '../../assets/images/BackgroundMap.png';
import BackgroundSign from '../../assets/images/backgroundSign.png';
import BackgroundSignAdmin from '../../assets/images/backgroundSignAdmin.jpg';
import BackgroundSignNewVers from '../../assets/images/BackgroundSignNewVersion.png';
import BackgroundSignPhone from '../../assets/images/backgroundSignSmatphone.png';
import BackgroundSignTab from '../../assets/images/backgroundSignTab.png';
import BackgroundSmartphone from '../../assets/images/BackgroundSmartphone.png';
import BackgroundSoluce from '../../assets/images/BackgroundSoluce.png';
import BackgroundSoluceSchool from '../../assets/images/BackgroundSoluceSchool.png';
import PicsBonhomme from '../../assets/images/bonhomme.png';
import PicsBoth from '../../assets/images/both.png';
import PicsBPI from '../../assets/images/BPIFrance.png';
import PicsBusiness from '../../assets/images/business.png';
import PicsBuisinessBuilding from '../../assets/images/businessBuilding.png';
import PicsCIC from '../../assets/images/CIC.png';
import PicsCite from '../../assets/images/CITE.png';
import PicsContact from '../../assets/images/contactBackground.png';
import PicsDashboard from '../../assets/images/dashboard.png';
import DefaultHeader from '../../assets/images/defaultprofileheader.png';
import PicsEcole from '../../assets/images/ecole.png';
import PicsEtudiant from '../../assets/images/etudiant.png';
import PicsExample from '../../assets/images/example.png';
import PicsFacebook from '../../assets/images/Facebook.png';
import BackgroundFirstFooter from '../../assets/images/firstFooter.png';
import PicsFontainer from '../../assets/images/fontainer.png';
import PicsFranceRelance from '../../assets/images/france-relance.png';
import PicsFrenchTech from '../../assets/images/french-tech.png';
import PicsGDB from '../../assets/images/GDB.png';
import PicsGoogle from '../../assets/images/google.png';
import PicsHome from '../../assets/images/home.png';
import PicsHomeSVG from '../../assets/images/home.svg';
import PicsCGU from '../../assets/images/icons/CGU.svg';
import PicsCookies from '../../assets/images/icons/cookies.svg';
import PicsExplore from '../../assets/images/icons/explore.svg';
import PicsHandDown from '../../assets/images/icons/handDown.svg';
import PicsInsights from '../../assets/images/icons/insights.svg';
import Picstiktok from '../../assets/images/icons/logoTiktok.svg';
import PicsPerson from '../../assets/images/icons/person.svg';
import PicsPodcast from '../../assets/images/icons/podcast.svg';
import PicsRGPD from '../../assets/images/icons/RGPD.svg';
import PicsSoluceIcon from '../../assets/images/icons/SolutionIcon.png';
import PicsSoluceIcon10 from '../../assets/images/icons/SolutionIcon10.png';
import PicsSoluceIcon11 from '../../assets/images/icons/SolutionIcon11.png';
import PicsSoluceIcon2 from '../../assets/images/icons/solutionIcon2.png';
import PicsSoluceIcon3 from '../../assets/images/icons/solutionIcon3.png';
import PicsSoluceIcon4 from '../../assets/images/icons/solutionIcon4.png';
import PicsSoluceIcon5 from '../../assets/images/icons/SolutionIcon5.png';
import PicsSoluceIcon6 from '../../assets/images/icons/SolutionIcon6.png';
import PicsSoluceIcon7 from '../../assets/images/icons/SolutionIcon7.png';
import PicsSoluceIcon8 from '../../assets/images/icons/SolutionIcon8.png';
import PicsSoluceIcon9 from '../../assets/images/icons/SolutionIcon9.png';
import PicsWork from '../../assets/images/icons/work.svg';
import PicsInfoFirst from '../../assets/images/infoFirstPart.png';
import PicsInfoSecond from '../../assets/images/infoSecondPart.png';
import PicsInfoThird from '../../assets/images/infoThirdPart.png';
import PicsInitiative from '../../assets/images/initiative.png';
import PicsInstagram from '../../assets/images/Instagram.png';
import PicsLeslie from '../../assets/images/LeslieHUE.png';
import PicsLinkedin from '../../assets/images/Linkedin.png';
import logoLinkpick from '../../assets/images/Logo_blanc.svg';
import PicsLogo from '../../assets/images/Logo.svg';
import PicsLogoAccelerateurWhite from '../../assets/images/LogoAccelerateurWhite.png';
import PicsLogoBPIWhite from '../../assets/images/LogoBpiWhite.png';
import PicsLogoCCIWhite from '../../assets/images/LogoCCIFranceWhite.png';
import PicsLogoCodevWhite from '../../assets/images/LogoCodevWhite.png';
import PicsLogoProvenceProWhite from '../../assets/images/LogoProvencePromotion.png';
import PicsLogoR from '../../assets/images/LogoR.png';
import LogoLinkpickBlanc from '../../assets/images/LogoWhiteBackground.svg';
import PicsLongchamp from '../../assets/images/longchamp.jpeg';
import PicsMapWhite from '../../assets/images/map_white.svg';
import PicsMediaExplenation from '../../assets/images/MediaExplenation.png';
import messageBox from '../../assets/images/messageBox.png';
import miniLogoLinkpick from '../../assets/images/miniLogo.png';
import BackgroundNewSign from '../../assets/images/newBackground.png';
import PicsNewsletter from '../../assets/images/newsletter.png';
import PicsPalais from '../../assets/images/palais.jpg';
import PicspartyPopper from '../../assets/images/party-popper.png';
import PicsPhotoAPropos2 from '../../assets/images/photo-apropos-2.png';
import PicsPhotoAPropos from '../../assets/images/photo-apropos.png';
import PicsConstat from '../../assets/images/PicsConstat.png';
import PicsMenContact from '../../assets/images/PicsContact.png';
import PicsRocket from '../../assets/images/PicsRocket.png';
import PicsPrint from '../../assets/images/prints.png';
import PicsProvencePromotion from '../../assets/images/provence-promotion.png';
import PicsQuentin from '../../assets/images/QuentinBICHI.png';
import PicsRecruteur from '../../assets/images/recruteur_img.png';
import PicsRecruteurContainer from '../../assets/images/recruteur.png';
import PicsSchool from '../../assets/images/school.png';
import PicsSchool2 from '../../assets/images/school2.png';
import PicsSchoolBuilding from '../../assets/images/schoolBuilding.png';
import PicsFirstSoluce from '../../assets/images/SoluceFirstPics.png';
import PicsSecondSoluce from '../../assets/images/SoluceSecondPics.png';
import PicsThirdSoluce from '../../assets/images/SoluceThirdPics.png';
import PicsSoluceFormation1 from '../../assets/images/SolutionFormationImages1.png';
import PicsSoluceFormation2 from '../../assets/images/SolutionFormationImages2.png';
import PicsSoluceFormation5 from '../../assets/images/SolutionFormationImages5.png';
import PicsSoluceFormation6 from '../../assets/images/SolutionFormationImages6.png';
import PicsSolutionImage from '../../assets/images/SolutionImage.png';
import PicsSolutionImage2 from '../../assets/images/SolutionImage2.png';
import PicsSolutionImage4 from '../../assets/images/SolutionImage4.png';
import PicsSolutionImage5 from '../../assets/images/SolutionImage5.png';
import PicsSolutionImage6 from '../../assets/images/SolutionImage6.png';
import PicsSparkles from '../../assets/images/sparkles.png';
import PicsSponsorsAWS from '../../assets/images/SponsorsAWS.png';
import PicsSponsorsEP from '../../assets/images/SponsorsEP.png';
import PicsSponsorsFrenchTech from '../../assets/images/SponsorsFrenchTech.png';
import PicsSponsorsGCB from '../../assets/images/SponsorsGDB.png';
import PicsSponsorsVeolia from '../../assets/images/SponsorsVeolia.png';
import PicsSunIllustration from '../../assets/images/sun-illustration.png';
import PicsTeddy from '../../assets/images/TeddyGIGANTINO.png';
import PicsBenjaminDenoyer from '../../assets/images/Testiment/BenjaminDenoyer.jpg';
import PicsHugoBudillon from '../../assets/images/Testiment/HugoBudillon.jpg';
import PicsPierreRammah from '../../assets/images/Testiment/PierreRammah.jpg';
import PicsRomainCordier from '../../assets/images/Testiment/RomainCordier.jpg';
import PicsSamuelMaarek from '../../assets/images/Testiment/SamuelMaarek.jpg';
import PicsWaelDehmani from '../../assets/images/Testiment/WaelDehmani.png';
import PicsWilfriedPelligrino from '../../assets/images/Testiment/WilfriedPelligrino.jpg';
import PicsUPE from '../../assets/images/UPE.png';
import PickLink from '../../assets/images/picklink.png';
import Aixmarseille from '../../assets/images/aixmarseille.png';
import Amandine from '../../assets/images/amandine.png';
import Christophe from '../../assets/images/christophe.png';
import Benjamin from '../../assets/images/benjamin.png';
import Veolia from '../../assets/images/veolia.png';
import Wilfried from '../../assets/images/wilfried.png';
import EcolePratique from '../../assets/images/ecolepratique.png';
import CV_Linkpick from '../../assets/images/CV_Linkpick.png';
import CV_Linkpick_pas_classique from '../../assets/images/CV_Linkpick_pas_classique.jpg';
import OpcoAfdas from '../../assets/images/opcoafdas.png';
import OpcoAtlas from '../../assets/images/opcoatlas.png';
import OpcoOcapiat from '../../assets/images/opcoocapiat.png';
import OpcoUniformation from '../../assets/images/opcouniformation.png';
import OpcoConstructys from '../../assets/images/opcoconstructys.png';
import Opcommerce from '../../assets/images/opcommerce.png';
import OpcoAkto from '../../assets/images/opcoakto.png';
import Opco2i from '../../assets/images/opco2i.png';
import OpcoMobilites from '../../assets/images/opcomobilites.png';
import OpcoEp from '../../assets/images/opcoep.png';
import OpcoSante from '../../assets/images/opcosante.png';
import CarrouselSign from '../../assets/images/carrousel_sign.png';
import HourGlass from '../../assets/images/hourglass.png';
import Actions from '../../assets/images/actions.png';
import Billings from '../../assets/images/billings.png';
import Degree from '../../assets/images/degree.png';
import Records from '../../assets/images/records.png';
import Trainings from '../../assets/images/trainings.png';
import TrainingsWithSheets from '../../assets/images/trainings_with_sheet.png';
import Candidate from '../../assets/images/candidate.png';
import Affiliate from '../../assets/images/affiliate.png';
import forgetPassword from '../../assets/images/forgetPassword.svg';
import waitingEmailConfirmation from '../../assets/images/waitingEmailConfirmation.svg';

import { defaultColors, defaultTheme } from './default';

export const colors = {
  ...defaultColors,
  primary: '#0060F9',
  primaryOpacite: '#F3F7FF',
  primaryOpacite1: '#DAE9FC',
  white: '#fff',
  red: '#D33D20',
  red2: '#FF5569',
  orange: '#F7931A',
  orange2: '#FFA755',
  green: '#47CEC1',
  grey: '#373759',
  grey2: '#636895',
  grey3: '#777B9B',
  grey4: '#f8f8fd',
  grey5: '#e9eaf2',
  grey6: '#333333',
  grey7: '#F9F9FF',
  black1: '#152652',
  black2: '#5D75A8',
  blueOp: '#0060F9',
  blue1: '#5A6DA1',
  blue2: '#152652',

  // Bleus

  bleuElectrique: '#0060F9',
  bleuMarine: '#152652',
  bleuArdoise: '#5D75A8',
  bleuPale: '#C0D9FF',
  bleuSaphir: '#004AC1',

  // Blancs
  blancGlacial: '#F3F7FF',
  blancGlacier: '#92ABD2',

  // Verts
  vertAmande: '#DBFAD8',
  vertProfond: '#008000',

  // Roses , Rouges, Violet
  rosePoudre: '#FBD3D5',
  roseElectrique: '#F50057',
  roseGuimauve: '#FAD7EE',
  lavandeDouce: '#E9D5FB',
  violetIntense: '#8631D6',
  fuchsiaRoyale: '#C2278C',
  framboiseRubis: '#BD0042',

  // Orange
  beigeVanille: '#FAE8D7',
  orangeFlamboyant: '#FA8100',

  blanc: '#FFFFFF',
};

export const fontSizes2 = {
  // paragraphes
  body: {
    '@media only screen and (max-width:1920px)': { fontSize: '14px' },
    '@media only screen and (max-width:1543px)': { fontSize: '13.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '13px' },
    '@media only screen and (max-width:810px)': { fontSize: '12.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '12px' }
  },
  bodyMd: {
    '@media only screen and (max-width:1920px)': { fontSize: '15px' },
    '@media only screen and (max-width:1543px)': { fontSize: '14.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '14px' },
    '@media only screen and (max-width:810px)': { fontSize: '13.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '13px' }
  },
  bodyLg: {
    '@media only screen and (max-width:1920px)': { fontSize: '16px' },
    '@media only screen and (max-width:1543px)': { fontSize: '15.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '15px' },
    '@media only screen and (max-width:810px)': { fontSize: '14.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '14px' }
  },

  // titres
  h2: {
    '@media only screen and (max-width:1920px)': { fontSize: '18px' },
    '@media only screen and (max-width:1543px)': { fontSize: '17.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '17px' },
    '@media only screen and (max-width:810px)': { fontSize: '16.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '16px' }
  },
  h2Lg: {
    '@media only screen and (max-width:1920px)': { fontSize: '20px' },
    '@media only screen and (max-width:1543px)': { fontSize: '19.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '19px' },
    '@media only screen and (max-width:810px)': { fontSize: '18.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '18px' }
  },
  h1: {
    '@media only screen and (max-width:1920px)': { fontSize: '24px' },
    '@media only screen and (max-width:1543px)': { fontSize: '23.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '23px' },
    '@media only screen and (max-width:810px)': { fontSize: '22.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '22px' }
  },
};

export const iconSizes = {
  // icônes
  iconSm: {
    '@media only screen and (max-width:1920px)': { fontSize: '16px', width: '16px', height: '16px' },
    '@media only screen and (max-width:1543px)': { fontSize: '15.5px', width: '15.5px', height: '15.5px' },
    '@media only screen and (max-width:1280px)': { fontSize: '15px', width: '15px', height: '15px' },
    '@media only screen and (max-width:810px)': { fontSize: '14.5px', width: '14.5px', height: '14.5px' },
    '@media only screen and (max-width:390px)': { fontSize: '14px', width: '14px', height: '14px' }
  },
  iconMd: {
    '@media only screen and (max-width:1920px)': { fontSize: '20px', width: '20px', height: '20px' },
    '@media only screen and (max-width:1543px)': { fontSize: '19px', width: '19px', height: '19px' },
    '@media only screen and (max-width:1280px)': { fontSize: '18px', width: '18px', height: '18px' },
    '@media only screen and (max-width:810px)': { fontSize: '17px', width: '17px', height: '17px' },
    '@media only screen and (max-width:390px)': { fontSize: '16px', width: '16px', height: '16px' }
  },
  iconLg: {
    '@media only screen and (max-width:1920px)': { fontSize: '24px', width: '24px', height: '24px' },
    '@media only screen and (max-width:1543px)': { fontSize: '23px', width: '23px', height: '23px' },
    '@media only screen and (max-width:1280px)': { fontSize: '22px', width: '22px', height: '22px' },
    '@media only screen and (max-width:810px)': { fontSize: '21px', width: '21px', height: '21px' },
    '@media only screen and (max-width:390px)': { fontSize: '20px', width: '20px', height: '20px' }
  }
};

export const padding = {
  xs: {
    '@media only screen and (max-width:1920px)': { padding: '6px' },
    '@media only screen and (max-width:1543px)': { padding: '5.5px' },
    '@media only screen and (max-width:1280px)': { padding: '5px' },
    '@media only screen and (max-width:810px)': { padding: '4.5px' },
    '@media only screen and (max-width:390px)': { padding: '4px' }
  },
  s: {
    '@media only screen and (max-width:1920px)': { padding: '10px' },
    '@media only screen and (max-width:1543px)': { padding: '9.5px' },
    '@media only screen and (max-width:1280px)': { padding: '9px' },
    '@media only screen and (max-width:810px)': { padding: '8.5px' },
    '@media only screen and (max-width:390px)': { padding: '8px' }
  },
  m: {
    '@media only screen and (max-width:1920px)': { padding: '15px' },
    '@media only screen and (max-width:1543px)': { padding: '14.5px' },
    '@media only screen and (max-width:1280px)': { padding: '14px' },
    '@media only screen and (max-width:810px)': { padding: '13.5px' },
    '@media only screen and (max-width:390px)': { padding: '13px' }
  },
  l: {
    '@media only screen and (max-width:1920px)': { padding: '20px' },
    '@media only screen and (max-width:1543px)': { padding: '19.5px' },
    '@media only screen and (max-width:1280px)': { padding: '19px' },
    '@media only screen and (max-width:810px)': { padding: '18.5px' },
    '@media only screen and (max-width:390px)': { padding: '18px' }
  },
  xl: {
    '@media only screen and (max-width:1920px)': { padding: '24px' },
    '@media only screen and (max-width:1543px)': { padding: '23.5px' },
    '@media only screen and (max-width:1280px)': { padding: '23px' },
    '@media only screen and (max-width:810px)': { padding: '22.5px' },
    '@media only screen and (max-width:390px)': { padding: '22px' }
  },
  xxl: {
    '@media only screen and (max-width:1920px)': { padding: '30px' },
    '@media only screen and (max-width:1543px)': { padding: '29.5px' },
    '@media only screen and (max-width:1280px)': { padding: '29px' },
    '@media only screen and (max-width:810px)': { padding: '28.5px' },
    '@media only screen and (max-width:390px)': { padding: '28px' }
  },
  xxxl: {
    '@media only screen and (max-width:1920px)': { padding: '48px' },
    '@media only screen and (max-width:1543px)': { padding: '46px' },
    '@media only screen and (max-width:1280px)': { padding: '44px' },
    '@media only screen and (max-width:810px)': { padding: '42px' },
    '@media only screen and (max-width:390px)': { padding: '40px' }
  }
};

export const margin = {
  xs: {
    '@media only screen and (max-width:1920px)': { margin: '6px' },
    '@media only screen and (max-width:1543px)': { margin: '5.5px' },
    '@media only screen and (max-width:1280px)': { margin: '5px' },
    '@media only screen and (max-width:810px)': { margin: '4.5px' },
    '@media only screen and (max-width:390px)': { margin: '4px' }
  },
  s: {
    '@media only screen and (max-width:1920px)': { margin: '10px' },
    '@media only screen and (max-width:1543px)': { margin: '9.5px' },
    '@media only screen and (max-width:1280px)': { margin: '9px' },
    '@media only screen and (max-width:810px)': { margin: '8.5px' },
    '@media only screen and (max-width:390px)': { margin: '8px' }
  },
  m: {
    '@media only screen and (max-width:1920px)': { margin: '15px' },
    '@media only screen and (max-width:1543px)': { margin: '14.5px' },
    '@media only screen and (max-width:1280px)': { margin: '14px' },
    '@media only screen and (max-width:810px)': { margin: '13.5px' },
    '@media only screen and (max-width:390px)': { margin: '13px' }
  },
  l: {
    '@media only screen and (max-width:1920px)': { margin: '20px' },
    '@media only screen and (max-width:1543px)': { margin: '19.5px' },
    '@media only screen and (max-width:1280px)': { margin: '19px' },
    '@media only screen and (max-width:810px)': { margin: '18.5px' },
    '@media only screen and (max-width:390px)': { margin: '18px' }
  },
  xl: {
    '@media only screen and (max-width:1920px)': { margin: '24px' },
    '@media only screen and (max-width:1543px)': { margin: '23.5px' },
    '@media only screen and (max-width:1280px)': { margin: '23px' },
    '@media only screen and (max-width:810px)': { margin: '22.5px' },
    '@media only screen and (max-width:390px)': { margin: '22px' }
  },
  xxl: {
    '@media only screen and (max-width:1920px)': { margin: '30px' },
    '@media only screen and (max-width:1543px)': { margin: '29.5px' },
    '@media only screen and (max-width:1280px)': { margin: '29px' },
    '@media only screen and (max-width:810px)': { margin: '28.5px' },
    '@media only screen and (max-width:390px)': { margin: '28px' }
  },
  '3xl': {
    '@media only screen and (max-width:1920px)': { margin: '48px' },
    '@media only screen and (max-width:1543px)': { margin: '46px' },
    '@media only screen and (max-width:1280px)': { margin: '44px' },
    '@media only screen and (max-width:810px)': { margin: '42px' },
    '@media only screen and (max-width:390px)': { margin: '40px' }
  }
};

export const gap = {
  xs: {
    '@media only screen and (max-width:1920px)': { gap: '6px' },
    '@media only screen and (max-width:1543px)': { gap: '5.5px' },
    '@media only screen and (max-width:1280px)': { gap: '5px' },
    '@media only screen and (max-width:810px)': { gap: '4.5px' },
    '@media only screen and (max-width:390px)': { gap: '4px' }
  },
  s: {
    '@media only screen and (max-width:1920px)': { gap: '10px' },
    '@media only screen and (max-width:1543px)': { gap: '9.5px' },
    '@media only screen and (max-width:1280px)': { gap: '9px' },
    '@media only screen and (max-width:810px)': { gap: '8.5px' },
    '@media only screen and (max-width:390px)': { gap: '8px' }
  },
  m: {
    '@media only screen and (max-width:1920px)': { gap: '15px' },
    '@media only screen and (max-width:1543px)': { gap: '14.5px' },
    '@media only screen and (max-width:1280px)': { gap: '14px' },
    '@media only screen and (max-width:810px)': { gap: '13.5px' },
    '@media only screen and (max-width:390px)': { gap: '13px' }
  },
  l: {
    '@media only screen and (max-width:1920px)': { gap: '20px' },
    '@media only screen and (max-width:1543px)': { gap: '19.5px' },
    '@media only screen and (max-width:1280px)': { gap: '19px' },
    '@media only screen and (max-width:810px)': { gap: '18.5px' },
    '@media only screen and (max-width:390px)': { gap: '18px' }
  },
  xl: {
    '@media only screen and (max-width:1920px)': { gap: '24px' },
    '@media only screen and (max-width:1543px)': { gap: '23.5px' },
    '@media only screen and (max-width:1280px)': { gap: '23px' },
    '@media only screen and (max-width:810px)': { gap: '22.5px' },
    '@media only screen and (max-width:390px)': { gap: '22px' }
  },
  xxl: {
    '@media only screen and (max-width:1920px)': { gap: '30px' },
    '@media only screen and (max-width:1543px)': { gap: '29.5px' },
    '@media only screen and (max-width:1280px)': { gap: '29px' },
    '@media only screen and (max-width:810px)': { gap: '28.5px' },
    '@media only screen and (max-width:390px)': { gap: '28px' }
  },
  '3xl': {
    '@media only screen and (max-width:1920px)': { gap: '48px' },
    '@media only screen and (max-width:1543px)': { gap: '46px' },
    '@media only screen and (max-width:1280px)': { gap: '44px' },
    '@media only screen and (max-width:810px)': { gap: '42px' },
    '@media only screen and (max-width:390px)': { gap: '40px' }
  }
};

export const components = {
  textField: {
    container: {
      position: "relative",
      width: "100%",
    },
    input: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      borderWidth: "1px",
      borderColor: colors.bleuPale,
      borderStyle: "solid",
      backgroundColor: colors.blancGlacial,
      borderRadius: "10px",
      width: "100%",
      height: "40px",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.bleuArdoise,
      outline: "none",
      color: colors.bleuMarine,
      placeholder: {
        color: colors.bleuMarine,
      },
      "&:hover": {
        borderColor: colors.bleuElectrique,
        backgroundColor: colors.blanc,
        "&::placeholder": {
          color: colors.bleuElectrique,
        }
      },
      "&:focus": {
        borderColor: colors.bleuElectrique,
        "&::placeholder": {
          color: colors.bleuElectrique,
        }
      },
      "&:disabled": {
        backgroundColor: colors.blancGlacial,
        borderColor: colors.bleuPale,
        cursor: "not-allowed",

        "&::placeholder": {
          color: colors.bleuArdoise,
        }
      },
    },
    inputError: {
      backgroundColor: colors.rosePoudre,
      borderColor: colors.roseElectrique,
    },
  },
  autocomplete: {
    container: {
      position: "relative",
      width: "100%",
    },
    inputContainer: {
      borderWidth: "1px",
      borderColor: colors.bleuPale,
      borderStyle: "solid",
      alignItems: "center",
      backgroundColor: colors.blancGlacial,
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      height: "40px",
      justifyContent: "space-between",
      ...combine(padding.s, padding.m),
      width: "100%",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      position: "relative",
    },
    input: {
      border: "none",
      outline: "none",
      width: "100%",
      fontFamily: "\"Roboto\", sans-serif",
      ...combine(fontSizes2.body),
      color: colors.bleuArdoise,
      background: "transparent",
      "&::placeholder": {
        color: colors.bleuArdoise,
        opacity: 1
      },
      "&:hover::placeholder": {
        color: colors.bleuElectrique,
        opacity: 1
      }
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors.bleuArdoise,
      transition: "color 0.2s ease-in-out",
    },
    icon: {
      ...combine(iconSizes.iconLg),
      fill: "currentColor",
    },
    optionsList: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      marginTop: "5px",
      borderRadius: "10px",
      backgroundColor: colors.blanc,
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
      maxHeight: "200px",
      overflowY: "auto",
    },
    option: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      cursor: "pointer",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.bleuArdoise,
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        backgroundColor: colors.blancGlacial,
        color: colors.bleuElectrique,
      }
    },
    optionSelected: {
      backgroundColor: colors.blancGlacial,
      color: colors.bleuElectrique,
    },
    noOptions: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      cursor: "pointer",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.bleuArdoise,
      fontStyle: "italic",
      textAlign: "center"
    },
    hover: {
      borderColor: colors.bleuElectrique,
      backgroundColor: colors.blanc,
      "& $iconContainer": {
        color: colors.bleuElectrique,
      }
    },
    focus: {
      borderColor: colors.bleuElectrique,
      backgroundColor: colors.blanc,
      "& $iconContainer": {
        color: colors.bleuElectrique,
      }
    },
    error: {
      backgroundColor: colors.rosePoudre,
      borderColor: colors.roseElectrique,
    }
  },
  AuthGoogleLinkedin: {
    button: {
      ...combine(padding.s, padding.m, gap.s),
      borderWidth: "1px",
      borderColor: "transparent",
      borderStyle: "solid",
      alignContent: "center",
      backgroundColor: colors.blancGlacial,
      borderRadius: "7px",
      display: "flex",
      flexDirection: "row",
      height: "min-content",
      position: "relative",
      width: "100%",
      overflow: "hidden",
      placeItems: "center",
      "&:hover": {
        borderWidth: "1px",
        borderColor: colors.bleuElectrique,
        backgroundColor: colors.bleuPale,
      },
      "&:disabled": {
        backgroundColor: colors.blancGlacial,
        cursor: "not-allowed",
        color: colors.bleuArdoise,
        "&:hover": {
          backgroundColor: colors.blancGlacial,
        },
      },
    },
    icon: {
      ...combine(iconSizes.iconLg),
      position: "relative",
      overflow: "visible",
    }
  },
  checkbox: {
    container: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      userSelect: "none",
      ...combine(gap.xs),
    },
    input: {
      position: "absolute",
      opacity: 0,
      cursor: "pointer",
      height: 0,
      width: 0,
    },
    checkmark: {
      ...combine(iconSizes.iconSm),
      backgroundColor: colors.blanc,
      border: `1px solid ${colors.bleuPale}`,
      borderRadius: "3px",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: colors.bleuElectrique,
        backgroundColor: colors.blancGlacial,
      },
    },
    checkmarkChecked: {
      backgroundColor: colors.bleuElectrique,
      borderColor: colors.bleuElectrique,
      "&:hover": {
        backgroundColor: colors.bleuSaphir,
        borderColor: colors.bleuSaphir,
      },
    },
    icon: {
      ...combine(fontSizes2.body),
      color: colors.blanc,
      display: "none",
    },
    iconChecked: {
      display: "block",
    },
    label: {
      ...combine(fontSizes2.body),
      fontWeight: "500",
      color: colors.bleuMarine,
      cursor: "pointer",
      fontFamily: "\"Montserrat\", sans-serif",
    },
    labelDisabled: {
      color: colors.bleuArdoise,
      cursor: "not-allowed",
    },
    disabled: {
      cursor: "not-allowed",
      backgroundColor: colors.blancGlacial,
      borderColor: colors.bleuPale,
      "&:hover": {
        backgroundColor: colors.blancGlacial,
        borderColor: colors.bleuPale,
      },
    },
  },
  select: {
    container: {
      position: "relative",
      width: "100%",
    },
    input: {
      ...combine(padding.s, padding.m),
      borderWidth: "1px",
      borderColor: colors.bleuPale,
      borderStyle: "solid",
      alignItems: "center",
      backgroundColor: colors.blancGlacial,
      borderRadius: "10px",
      display: "flex",
      flexDirection: "row",
      height: "40px",
      justifyContent: "space-between",
      width: "100%",
      cursor: "pointer",
      position: "relative",
      color: colors.bleuArdoise,
      "&:hover": {
        borderColor: colors.bleuElectrique,
        backgroundColor: colors.blanc,
        "&::placeholder": {
          color: colors.bleuElectrique,
        }
      },
      "&:focus": {
        borderColor: colors.bleuElectrique,
        "&::placeholder": {
          color: colors.bleuElectrique,
        }
      },
      "&:disabled": {
        backgroundColor: colors.blancGlacial,
        borderColor: colors.bleuPale,
        cursor: "not-allowed",
        "&::placeholder": {
          color: colors.bleuArdoise,
        }
      },
    },
    inputField: {
      border: "none",
      outline: "none",
      width: "100%",
      fontFamily: "\"Roboto\", sans-serif",
      ...combine(fontSizes2.body),
      color: colors.bleuArdoise,
      background: "transparent",
      "&::placeholder": {
        color: colors.bleuArdoise,
        opacity: 1
      },
      "&:hover::placeholder": {
        color: colors.bleuElectrique,
        opacity: 1
      }
    },
    arrow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: colors.bleuArdoise,
    },
    hover: {
      borderColor: colors.bleuElectrique,
      backgroundColor: colors.blanc,
      "& $arrow": {
        color: colors.bleuElectrique,
      }
    },
    focus: {
      borderColor: colors.bleuElectrique,
      backgroundColor: colors.blanc,
      "& $arrow": {
        color: colors.bleuElectrique,
      }
    },
    error: {
      backgroundColor: colors.rosePoudre,
      borderColor: colors.roseElectrique,
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      marginTop: "5px",
      borderRadius: "10px",
      backgroundColor: colors.blanc,
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 10,
      maxHeight: "200px",
      overflowY: "auto",
    },
    option: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      cursor: "pointer",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.bleuArdoise,
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        backgroundColor: colors.blancGlacial,
        color: colors.bleuElectrique,
      }
    },
    optionSelected: {
      backgroundColor: colors.blancGlacial,
      color: colors.bleuElectrique,
    },
    optionText: {
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }
  },
  phoneInput: {
    container: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      position: "relative",
      width: "100%",
      display: "flex",
      alignItems: "center",
      backgroundColor: colors.blancGlacial,
      borderRadius: "10px",
      border: `1px solid ${colors.bleuPale}`,
      height: "40px",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.bleuMarine,
      outline: "none",
      "&:hover": {
        borderColor: colors.bleuElectrique,
        backgroundColor: colors.blanc,
      },
      "&:focus-within": {
        borderColor: colors.bleuElectrique,
        backgroundColor: colors.blanc,
      },
      "&:disabled": {
        backgroundColor: colors.blancGlacial,
        borderColor: colors.bleuPale,
        cursor: "not-allowed",
      },
    },
    countrySelector: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      minWidth: "70px",
    },
    input: {
      ...combine(fontSizes2.body),
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
      color: colors.bleuMarine,
      fontFamily: "\"Roboto\", sans-serif",
      flex: 1,
      padding: 0,
      margin: 0,
    },
    inputError: {
      backgroundColor: colors.rosePoudre,
      borderColor: colors.roseElectrique,
    },
    dropdown: {
      position: "absolute",
      top: "100%",
      left: 0,
      backgroundColor: colors.blanc,
      border: `1px solid ${colors.bleuPale}`,
      borderRadius: "10px",
      boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.1)",
      zIndex: 1000,
      maxHeight: "200px",
      overflowY: "auto",
      marginTop: "4px",
      width: "max-content",
    },
    option: {
      ...combine(padding.s, padding.m, fontSizes2.body),
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      backgroundColor: "transparent",
      borderBottom: `1px solid ${colors.blancGlacial}`,
      whiteSpace: "nowrap",
      transition: "background-color 0.2s ease",
      fontFamily: "\"Roboto\", sans-serif",
      color: colors.bleuMarine,
      fontWeight: 400,
      "&:hover": {
        backgroundColor: colors.blancGlacial,
      },
    },
    optionSelected: {
      backgroundColor: colors.blancGlacial,
    },
    flag: {
      width: "20px",
      height: "15px",
      borderRadius: "2px",
      objectFit: "cover",
    },
    dialCode: {
      ...combine(fontSizes2.body, padding.s),
      color: colors.bleuMarine,
      fontWeight: 400,
    },
    countryName: {
      ...combine(fontSizes2.body),
      color: colors.bleuArdoise,
      flex: 1,
    },
    arrow: {
      ...combine(fontSizes2.body),
      color: colors.bleuArdoise,
    },
    error: {
      backgroundColor: colors.rosePoudre,
      borderColor: colors.roseElectrique,
    },
  },
};

export const HEIGHT_TAB = 50;

export const images = {
  DefaultHeader,
  miniLogoLinkpick,
  logoLinkpick,
  PicsAccelerateur,
  PicsApple,
  PicsCGU,
  PicsCookies,
  PicsExample,
  PicsDashboard,
  PicsEcole,
  PicsEtudiant,
  PicsExplore,
  PicsFacebook,
  PicsFontainer,
  PicsFranceRelance,
  PicsFrenchTech,
  PicsGoogle,
  PicsHandDown,
  PicsHome,
  BackgroundSignPhone,
  BackgroundSignTab,
  PicsHomeSVG,
  PicsInitiative,
  PicsInsights,
  PicsInstagram,
  PicsLeslie,
  PicsLinkedin,
  PicsLogo,
  PicsLogoR,
  BackgroundSmartphone,
  PicsLongchamp,
  PicsNewsletter,
  PicsPalais,
  PicsPerson,
  PicsPhotoAPropos,
  PicsPhotoAPropos2,
  PicsPodcast,
  PicsPrint,
  PicsProvencePromotion,
  PicsQuentin,
  PicsRGPD,
  PicsRecruteur,
  PicsRecruteurContainer,
  PicsSparkles,
  PicsSunIllustration,
  PicsWork,
  PicspartyPopper,
  PicsBusiness,
  PicsSchool2,
  PicsSchool,
  PicsBonhomme,
  PicsInfoThird,
  PicsInfoSecond,
  PicsInfoFirst,
  PicsFormBackground,
  PicsBuisinessBuilding,
  PicsBoth,
  PicsContact,
  // PicsMap,
  PicsMapWhite,
  PicsSoluceIcon,
  PicsSoluceIcon2,
  PicsSoluceIcon3,
  PicsSoluceIcon4,
  PicsSoluceIcon5,
  PicsSoluceIcon6,
  PicsSolutionImage,
  PicsSolutionImage2,
  PicsSolutionImage4,
  PicsSolutionImage5,
  PicsSolutionImage6,
  BackgroundSign,
  BackgroundSignAdmin,
  BackgroundSignNewVers,
  BackgroundHome,
  backgroundBuild,
  PicsLogoCCIWhite,
  PicsLogoProvenceProWhite,
  PicsLogoBPIWhite,
  PicsLogoAccelerateurWhite,
  BackgroundFirstFooter,
  BackgroundSoluce,
  BackgroundMap,
  BackgroundCloud,
  PicsRocket,
  BackgroundAbout,
  PicsConstat,
  PicsMenContact,
  PicsFirstSoluce,
  PicsSecondSoluce,
  Picstiktok,
  PicsSchoolBuilding,
  BackgroundSoluceSchool,
  PicsArnaud,
  PicsSponsorsAWS,
  PicsSponsorsEP,
  PicsSponsorsFrenchTech,
  PicsSponsorsGCB,
  PicsSponsorsVeolia,
  PicsUPE,
  PicsBPI,
  PicsCIC,
  PicsCite,
  PicsGDB,
  PicsTeddy,
  PicsThirdSoluce,
  PicsSoluceIcon7,
  PicsSoluceIcon8,
  PicsSoluceIcon9,
  PicsSoluceIcon10,
  PicsSoluceIcon11,
  PicsSamuelMaarek,
  PicsWilfriedPelligrino,
  PicsRomainCordier,
  PicsHugoBudillon,
  PicsBenjaminDenoyer,
  PicsWaelDehmani,
  PicsLogoCodevWhite,
  PicsSoluceFormation1,
  PicsSoluceFormation2,
  PicsSoluceFormation5,
  PicsSoluceFormation6,
  messageBox,
  PicsPierreRammah,
  PicsMediaExplenation,
  LogoLinkpickBlanc,
  AnimSecondPart,
  AnimConnexion,
  AnimConnexion2,
  BackgroundNewSign,
  PickLink,
  Aixmarseille,
  Amandine,
  Christophe,
  Benjamin,
  Veolia,
  Wilfried,
  EcolePratique,
  CV_Linkpick,
  CV_Linkpick_pas_classique,
  OpcoAfdas,
  OpcoAtlas,
  OpcoOcapiat,
  OpcoUniformation,
  OpcoConstructys,
  Opcommerce,
  OpcoAkto,
  Opco2i,
  OpcoMobilites,
  OpcoEp,
  OpcoSante,
  CarrouselSign,
  HourGlass,
  Actions,
  Degree,
  Billings,
  Trainings,
  Records,
  TrainingsWithSheets,
  Candidate,
  Affiliate,
  forgetPassword,
  waitingEmailConfirmation,
};

export const boxShadows = [
  '0px 0px 35px 0px #313A8540',
  '5px 5px 35px 0px #D2D5EA59',
  '0px 0px 35px rgba(49, 58, 133, 0.25)',
];

export const background = [
  `linear-gradient(180deg, rgba(49, 58, 133, 0) 0%, ${colors.primary2} 100%)`,
];
export const theme = {
  ...defaultTheme,
  breakpoints: {
    values: {
      xs: 250,
      sm: 640,
      md: 1024,
      lg: 1280,
      xl: 1770,
    },
  },
  // button: {
  //   fontFamily: 'Montserrat',
  //   fontSize: 20,
  //   fontWeight: 400,
  //   lineHeight: '110%',
  // },
  headerTitle: {
    fontFamily: 'Montserrat',
    color: '#152652',
    fontWeight: 600,
    lineHeight: '100%',
    fontSize: '18px',
    // '@media only screen and (max-width: 1543px)': { fontSize: '15px' }, // 16px
    // '@media only screen and (max-width: 1279px)': { fontSize: '14.5px' }, // 15.5px
    // '@media only screen and (max-width: 810px)': { fontSize: '14px' }, // 15px
    // '@media only screen and (max-width: 390px)': { fontSize: '13.5px' }, // 14.5px
  },
  headerSubTitle: {
    fontFamily: 'Roboto',
    color: '#5D75A8   ',
    fontWeight: 400,
    fontSize: '16px',
    // '@media only screen and (max-width: 1543px)': { fontSize: '15px' },
    // '@media only screen and (max-width: 1279px)': { fontSize: '14.5px' },
    // '@media only screen and (max-width: 810px)': { fontSize: '14px' },
    // '@media only screen and (max-width: 390px)': { fontSize: '13.5px' },
  },
  mainTitle: {
    fontFamily: 'Montserrat',
    color: '#152652',
    fontWeight: 600,
    fontSize: '16px', // 17px
    '@media only screen and (max-width: 1543px)': { fontSize: '15px' }, // 16px
    '@media only screen and (max-width: 1279px)': { fontSize: '14.5px' }, // 15.5px
    '@media only screen and (max-width: 810px)': { fontSize: '14px' }, // 15px
    '@media only screen and (max-width: 390px)': { fontSize: '13.5px' }, // 14.5px
  },
  title: {
    fontFamily: 'Montserrat',
    color: '#152652',
    lineHeight: '100%',
    fontWeight: 600,
    fontSize: '15px', // 15px
    '@media only screen and (max-width: 1543px)': { fontSize: '14.5px' }, // 14.5px
    '@media only screen and (max-width: 1279px)': { fontSize: '14px' }, // 14px
    '@media only screen and (max-width: 810px)': { fontSize: '13.5px' }, // 13.5px
    '@media only screen and (max-width: 390px)': { fontSize: '13px' }, // 13px
  },
  titleMediaQuery: {
    '@media only screen and (max-width: 1543px)': { fontSize: '14.5px' }, // 14.5px
    '@media only screen and (max-width: 1279px)': { fontSize: '14px' }, // 14px
    '@media only screen and (max-width: 810px)': { fontSize: '13.5px' }, // 13.5px
    '@media only screen and (max-width: 390px)': { fontSize: '13px' }, // 13px
  },
  subTitle: {
    fontFamily: 'Roboto',
    color: '#5D75A8',
    fontWeight: 400,
    fontSize: '14px', // 15px
    '@media only screen and (max-width: 1543px)': { fontSize: '13.5px' },
    '@media only screen and (max-width: 1279px)': { fontSize: '13px' },
    '@media only screen and (max-width: 810px)': { fontSize: '12.5px' },
    '@media only screen and (max-width: 390px)': { fontSize: '12px' },
  },
  subTitleMediaQuery: {
    '@media only screen and (max-width: 1543px)': { fontSize: '13.5px' },
    '@media only screen and (max-width: 1279px)': { fontSize: '13px' },
    '@media only screen and (max-width: 810px)': { fontSize: '12.5px' },
    '@media only screen and (max-width: 390px)': { fontSize: '12px' },
  },
  infoText: {
    fontFamily: 'Roboto',
    color: '#5D75A8',
    fontWeight: 400,
    fontSize: '14px',
    '@media only screen and (max-width: 1543px)': { fontSize: '13.5px' },
    '@media only screen and (max-width: 1279px)': { fontSize: '13px' },
    '@media only screen and (max-width: 810px)': { fontSize: '12.5px' },
    '@media only screen and (max-width: 390px)': { fontSize: '12px' },
  },
  infoIcon: {
    color: '#5D75A8',
    marginRight: '6px',
    fontSize: '20px',
    '@media only screen and (max-width: 1543px)': { fontSize: '19px', marginRight: '5.5px' },
    '@media only screen and (max-width: 1279px)': { fontSize: '18px', marginRight: '5px' },
    '@media only screen and (max-width: 810px)': { fontSize: '16px', marginRight: '4.5px' },
    '@media only screen and (max-width: 390px)': { fontSize: '14px', marginRight: '4px' },
  },
  smallIcon: {
    color: '#5D75A8',
    marginRight: '4.5px',
    fontSize: '16px',
    '@media only screen and (max-width: 1543px)': { fontSize: '15px', marginRight: '4px' },
    '@media only screen and (max-width: 1279px)': { fontSize: '14px', marginRight: '4px' },
    '@media only screen and (max-width: 810px)': { fontSize: '13px', marginRight: '3.5px' },
    '@media only screen and (max-width: 390px)': { fontSize: '12px', marginRight: '3.5px' },
  },
  ellipsis95: {
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '95%',
  },
  ellipsis90: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '90%',
  },
  ellipsis85: {
    display: 'block',
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // maxWidth: 'calc(100% - 112px)',
  },
  ellipsis80: {
    // whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '80%',
  },
  container: {
    padding: '50px',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    '@media only screen and (max-width:768px)': { padding: '20px' },
  },
  containerNoScroll: {
    padding: '50px',
    height: 'calc(100vh - 65px)',
    overflow: 'hidden',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    '@media only screen and (max-width:768px)': { padding: '20px', height: '100%' },
  },
  containerNoScrollWithTab: {
    padding: '50px',
    height: `calc(100vh - ${HEIGHT_TAB + 65}px)`,
    overflow: 'hidden',
    '@media only screen and (max-width:1543px)': { padding: '42px' },
    '@media only screen and (max-width:1440px)': { padding: '34px' },
    '@media only screen and (max-width:768px)': { padding: '20px', height: '100%' },
  },
  loader: {
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, .05)',
    top: 0,
    left: 0,
    borderRadius: 20,
    width: '100%',
    height: '100%',
    zIndex: 9999
  },
  tab: {
    padding: '6px 20px',
    border: '1px solid #C0D9FF',
    borderBottomWidth: 0,
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    height: HEIGHT_TAB,
    maxWidth: 1000,
    background: '#F3F7FF',
    color: '#5A6DA1',
    fontWeight: 500,
    "&:hover": {
      color: '#0060F9',
      backgroundColor: "white",
      opacity: 1,
    },
  },
  thinTab: {
    height: 40,
    border: '1px solid #C0D9FF',
  },
  activeTab: {
    background: "white",
    color: '#152652',
    fontWeight: 600,
    "&:hover": {
      color: '#152652',
    },
  },
  tabPanel: {
    background: 'white',
    borderRadius: '0 10px 56px 56px',
    padding: '20px',
    height: '100%',
  },
  containerContent: {
    background: 'white',
    borderRadius: '10px 10px 56px 56px',
    padding: '20px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  formikAutocomplete: {
    minWidth: '220px',
    '@media (max-width: 768px)': {
      width: '100% !important',
    },
    '& .MuiInputLabel-root': {
      fontFamily: 'Montserrat',
      fontSize: '13.5px',
      color: '#5D75A8',
      fontWeight: 500,
    },
    '& .MuiSvgIcon-root': {
      color: '#5D75A8!important',
    },
    '& :hover': {
      cursor: 'pointer',
      '& .MuiInputLabel-formControl': {
        color: '#0060F9!important',
      },
      '& .MuiSvgIcon-root': {
        color: '#0060F9!important',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0060F9!important',
      }
    }
  },
  formikTextField: {
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Montserrat',
      fontSize: '13.5px',
      color: '#92ABD2!important',
      fontWeight: 500,
    },
    '& input::placeholder': {
      color: '#92ABD2!important',
      opacity: 1,
    },
    '& :hover': {
      cursor: 'pointer',
      '& .MuiInputLabel-formControl': {
        color: '#0060F9!important',
      },
      '& .MuiSvgIcon-root': {
        color: '#0060F9!important',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0060F9!important',
      }
    }
  },
  formikTextFieldWhite: {
    '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
      opacity: 1,
      display: 'inline',
    },
    '& .MuiInputBase-root': {
      borderRadius: '10px!important',
      backgroundColor: 'white',
      cursor: 'pointer',
    },
    '& .MuiInputBase-input': {
      cursor: 'pointer',
    },
    '& .PhoneInput': {
      height: '40px',
      '& > *': {
        backgroundColor: 'white',
        border: '1px solid #C0D9FF !important',
        borderRadius: 6,
        padding: '0 16px',
        height: '100%',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: '#152652',
        outline: 'none',
      },
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Montserrat',
      fontSize: '13.5px',
      color: '#92ABD2!important',
      fontWeight: 500,
    },
    '& .MuiInputBase-input::placeholder': {
      fontFamily: 'Montserrat',
      color: '#92ABD2!important',
      fontWeight: 500,
      opacity: 1,
    },
    '& .MuiFormLabel-root': {
      fontSize: '13.5px',
      color: '#92ABD2!important',
      marginBottom: 4,
      display: "block",
    },
    '& .MuiInputBase-root:hover': {
      '& .MuiInputLabel-formControl': {
        color: '#0060F9!important',
      },
      '& .MuiSvgIcon-root': {
        color: '#0060F9!important',
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0060F9!important',
      }
    }
  },
  formikTextFieldWhiteError: {
    '& .MuiInputBase-root': {
      borderRadius: '10px!important',
      backgroundColor: '#FBD3D5',
      cursor: 'pointer',
    },
    '& .MuiInputBase-input': {
      cursor: 'pointer',
    },
    '& .PhoneInput': {
      height: '40px',
      '& > *': {
        backgroundColor: '#FBD3D5',
        border: '1px solid #F50057 !important',
        borderRadius: 6,
        padding: '0 16px',
        height: '100%',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: '#F50057',
        outline: 'none',
      },
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Montserrat',
      fontSize: '13.5px',
      color: '#F50057!important',
      fontWeight: 500,
    },
    '& .MuiInputBase-input::placeholder': {
      fontFamily: 'Montserrat',
      color: '#F50057!important',
      fontWeight: 500,
      opacity: 1,
    },
    '& .MuiFormLabel-root': {
      fontSize: '13.5px',
      color: '#92ABD2!important',
      marginBottom: 4,
      display: "block",
    },
    '& fieldset': {
      borderColor: '#F50057!important',
    }
  },
  formikTextFieldWhiteDisabled: {
    '& input[type="number"]::-webkit-inner-spin-button, & input[type="number"]::-webkit-outer-spin-button': {
      display: 'inline',
    },
    '& .MuiInputBase-root': {
      borderRadius: '10px!important',
      backgroundColor: '#F3F7FF',
      cursor: 'not-allowed',
    },
    '& .MuiInputBase-input': {
      cursor: 'not-allowed',
      color: '#999999',
    },
    '& .PhoneInput': {
      height: '40px',
      '& > *': {
        backgroundColor: '#f5f5f5',
        border: '1px solid #d0d0d0 !important',
        borderRadius: 6,
        padding: '0 16px',
        height: '100%',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: '#999999',
        outline: 'none',
        cursor: 'not-allowed',
      },
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Montserrat',
      fontSize: '13.5px',
      color: '#92ABD2!important',
      fontWeight: 500,
    },
    '& .MuiInputBase-input::placeholder': {
      fontFamily: 'Montserrat',
      color: '#92ABD2!important',
      fontWeight: 500,
      opacity: 1,
    },
    '& .MuiFormLabel-root': {
      fontSize: '13.5px',
      color: '#92ABD2!important',
      marginBottom: 4,
      display: 'block',
    },
  },
  alertErrorText: {
    fontFamily: "\"Roboto\", sans-serif",
    fontSize: "14px",
    textAlignment: "left",
    color: "#f50057",
  },
  greyButton: {
    transition: 'none',
    fontWeight: '500',
    '&:hover': {
      color: '#0060F9',
      backgroundColor: '#F3F7FF',
      border: '1px solid #0060F9',
      transition: 'none',
    },
  },
  lightBlueButton: {
    color: '#0060F9',
    backgroundColor: '#F3F7FF',
    border: '1px solid #0060F9',
    transition: 'none',
    '&:hover': {
      backgroundColor: '#0060F9',
      color: 'white',
      transition: 'none',
    },
  },
  lightRedButton: {
    color: '#F50057',
    backgroundColor: '#FBD3D5',
    border: '1px solid #F50057',
    transition: 'none',
    '&:hover': {
      backgroundColor: '#F50057',
      color: 'white',
      transition: 'none',
    },
  },
  filtersContainerHeader: {
    display: 'flex',
    alignContent: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  buttonBase: {
    margin: '0px 3px',
    alignSelf: 'baseline',
    borderRadius: '20px',
    border: '1px solid #C0D9FF',
    backgroundColor: '#F3F7FF',
    width: '26px',
    display: 'flex',
    justifyContent: 'center',
    height: '26px',
    alignItems: 'center',
    cursor: 'pointer',
    "&:hover": {
      border: '1px solid #0060F9',
      "& svg": {
        color: '#0060F9',
      }
    }
  },
  buttonCFADashboard: {
    backgroundColor: '#c0d9ff',
    borderRadius: '400px',
    padding: '4px 10px',
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    height: 'auto',
    justifyContent: 'center',
    border: '1px solid #c0d9ff',
    transition: '0s',
    '&:hover': {
      transition: '0s',
      border: '1px solid #0060f9',
      backgroundColor: '#c0d9ff',
    },
  },
  buttonCFADashboardText: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '13px',
    textAlign: 'center',
    color: '#0060f9',
  },
  buttonIcon: {
    height: '16px',
    width: '16px',
    color: '#5A6DA1',
  },
  transform45: {
    transform: 'rotate(45deg)',
  },
  paper: {
    backgroundColor: '#F3F7FF',
    padding: '20px 0px 0px 20px',
    borderRadius: '36px',
    height: '100%',
  },
  recordSection: {
    backgroundColor: "#F3F7FF",
    padding: "24px",
    borderRadius: "10px",
    display: 'flex',
    flexFlow: 'column',
    gap: "24px",
  },
  blueBar: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: '5px'
  },
  recordStep: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    backgroundColor: 'white',
    justifyContent: 'center',
    fontSize: '13px',
    color: '#92ABD2',
    borderRadius: '4px',
  },
  recordStepIcon: {
    fontSize: '20px',
    marginRight: '8px',
  },
  chipValid: {
    background: '#DBFAD8',
    color: '#008000'
  },
  chipPending: {
    background: '#FAE8D7',
    color: '#FA8100'
  },
  chipError: {
    background: '#FBD3D5',
    color: '#F50057'
  },
  chipDisabled: {
    background: '#F3F7FF',
    color: '#92ABD2'
  },
  chipAction: {
    background: '#C0D9FF',
    color: '#0060F9'
  },
  typography: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '110%',
    // Header Font
    h1: {
      fontFamily: 'Montserrat',
      fontWeight: 800,
      lineHeight: '110%',
      textShadow: '#0A45A3 -4px 4px',
      color: 'white',
      '@media only screen and (max-width:1920px)': { fontSize: '24px' },
      '@media only screen and (max-width:1600px)': { fontSize: '15.00px' },
      '@media only screen and (max-width:1200px)': { fontSize: '13.500px' },
    },
    // Big title part
    h2: {
      fontFamily: 'Montserrat',
      fontSize: 40,
      textTransform: 'uppercase',
      fontWeight: 800,
      '@media (max-width: 1024px)': {
        fontSize: 25,
      },
    },
    // title each part
    h3: {
      fontFamily: 'Montserrat',
      fontSize: 30,
      textTransform: 'uppercase',
      color: '#152652',
      fontWeight: 800,
      textShadow: '#d8e1f0 -4px 4px',
      '@media (max-width: 1024px)': {
        fontSize: 20,
      },
    },
    // title cubes
    h4: {
      fontFamily: 'Montserrat',
      fontSize: 20,
      fontWeight: 700,
      color: '#152652',
      textTransform: 'none',
      '@media (max-width: 1024px)': {
        fontSize: 18,
      },
    },
    // title card
    h5: {
      fontFamily: 'Montserrat',
      fontSize: 24,
      fontWeight: 800,
      lineHeight: '100%',
      textTransform: 'none',
      '@media (max-width:768px)': {
        fontSize: 20,
      },
    },
    // title footer
    h6: {
      fontFamily: 'Montserrat',
      fontSize: 17,
      fontWeight: 800,
      color: 'white',
      textTransform: 'uppercase',
      '@media (max-width: 1024px)': {
        fontSize: 15,
      },
    },
    // text
    subtitle1: {
      fontWeight: 400,
      lineHeight: '100%',
      textDecoration: 'none',
      '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
      '@media only screen and (max-width:1600px)': { fontSize: '15px' },
    },
    // text white
    subtitle2: {
      fontWeight: 400,
      color: '#5D75A8',
      lineHeight: '100%',
      textDecoration: 'none',
      '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
      '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
    },
    button: {
      fontFamily: 'Montserrat',
      fontWeight: 600,
      color: 'white',
      textDecoration: 'none',
      textTransform: 'none',
      '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
      '@media only screen and (max-width:1600px)': { fontSize: '14.00px' },
    },
  },
  palette: {
    primary: {
      main: '#0060F9',
      contrastText: colors.white,
    },
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  fontSizes: (size) => {
    if (window.innerWidth < 768) {
      return 0.9 * size;
    }
    if (window.innerWidth < 1440) {
      return 0.75 * size;
    }
    if (window.innerWidth < 1280) {
      return 0.67 * size;
    } else return size;
  },
};

export default theme;